// extracted by mini-css-extract-plugin
module.exports = {"badge":"RoundBadge__badge__1LUIj"};